var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoGrasaSubcutanea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.444,
    height: 39.948,
    viewBox: "0 0 50.444 39.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13741.146 11444.068)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13832.695 -11616.504)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.549 177.662)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.1,244.027a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,573.1,244.027Z",
    transform: "translate(-536.331 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.792,244.027a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,476.792,244.027Z",
    transform: "translate(-447.375 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.482,244.027a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,380.482,244.027Z",
    transform: "translate(-358.419 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.171,244.027a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,284.171,244.027Z",
    transform: "translate(-269.462 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.859,244.027a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,187.859,244.027Z",
    transform: "translate(-180.505 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.549,244.027a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,91.549,244.027Z",
    transform: "translate(-91.549 -240.868)",
    fill: "#394f65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.126 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.413,244.027a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,669.413,244.027Z",
    transform: "translate(-669.413 -240.868)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.226 184.743)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.258,336.77a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,621.258,336.77Z",
    transform: "translate(-584.486 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.947,336.77a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,524.947,336.77Z",
    transform: "translate(-495.53 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.637,336.77a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,428.637,336.77Z",
    transform: "translate(-406.574 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.326,336.77a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,332.326,336.77Z",
    transform: "translate(-317.617 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.015,336.77a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,236.015,336.77Z",
    transform: "translate(-228.661 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.705,336.77a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,139.705,336.77Z",
    transform: "translate(-139.705 -333.611)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.226 198.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.258,523.254a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,621.258,523.254Z",
    transform: "translate(-584.486 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.947,523.254a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,524.947,523.254Z",
    transform: "translate(-495.53 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.637,523.254a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,428.637,523.254Z",
    transform: "translate(-406.574 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.326,523.254a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,332.326,523.254Z",
    transform: "translate(-317.617 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.015,523.254a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,236.015,523.254Z",
    transform: "translate(-228.661 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.705,523.254a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,139.705,523.254Z",
    transform: "translate(-139.705 -520.095)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.549 191.902)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.1,430.512a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,573.1,430.512Z",
    transform: "translate(-536.331 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.792,430.512a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,476.792,430.512Z",
    transform: "translate(-447.375 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.482,430.512a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,380.482,430.512Z",
    transform: "translate(-358.419 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.171,430.512a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,284.171,430.512Z",
    transform: "translate(-269.462 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.859,430.512a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,187.859,430.512Z",
    transform: "translate(-180.505 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.549,430.512a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,91.549,430.512Z",
    transform: "translate(-91.549 -427.353)",
    fill: "#394f65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.413,430.512a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,669.413,430.512Z",
    transform: "translate(-669.413 -427.353)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.549 206.065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.1,616a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,573.1,616Z",
    transform: "translate(-536.331 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.792,616a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,476.792,616Z",
    transform: "translate(-447.375 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.482,616a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,380.482,616Z",
    transform: "translate(-358.419 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.171,616a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,284.171,616Z",
    transform: "translate(-269.462 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.859,616a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,187.859,616Z",
    transform: "translate(-180.505 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.549,616a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,91.549,616Z",
    transform: "translate(-91.549 -612.837)",
    fill: "#394f65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.413,616a3.159,3.159,0,1,0,3.159-3.159A3.163,3.163,0,0,0,669.413,616Z",
    transform: "translate(-669.413 -612.837)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M175.816,172.436H135.5a1.849,1.849,0,1,0,0,3.7h40.316a1.849,1.849,0,1,0,0-3.7Z",
    transform: "translate(-38.887)",
    fill: "#394f65"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGrasaSubcutanea);
export default __webpack_public_path__ + "static/media/ICO-GRASA-SUBCUTANEA.eccd78339c3f0bde441706f48512d25d.svg";
export { ForwardRef as ReactComponent };